import React from 'react';
import styled from 'styled-components';
import { MarketBargainLabelEnum } from 'utils/types/AiPredictorModels';

const Badge = styled.span`
    display: inline-flex;
    align-items: center;
    padding: 5px 14px;
    border-radius: 20px;
    font-size: var(--font-size-body-3);
    font-weight: 700;
    letter-spacing: 0.3px;

    &.below-market {
        background: var(--color-success-background);
        color: var(--color-success);
        border: 1.5px solid var(--color-success);
    }

    &.above-market {
        background: var(--color-error-background);
        color: var(--color-error);
        border: 1.5px solid var(--color-error);
    }

    &.at-market {
        background: var(--color-info-background);
        color: var(--color-warning);
        border: 1.5px solid var(--color-warning);
    }
`;

const getVariantClass = (label: MarketBargainLabelEnum): string => {
    switch (label) {
    case MarketBargainLabelEnum.PonizejRynku: return 'below-market';
    case MarketBargainLabelEnum.PowyzejRynku: return 'above-market';
    case MarketBargainLabelEnum.WCenieRynkowej: return 'at-market';
    default: return 'at-market';
    }
};

interface BargainBadgeProps {
    label: MarketBargainLabelEnum;
}

const BargainBadge = ({ label }: BargainBadgeProps) => <Badge className={getVariantClass(label)}>{label}</Badge>;

export default BargainBadge;
